var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 89,
    viewBox: "0 0 280 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.637695H280V81.0333C280 85.3302 276.517 88.8135 272.22 88.8135H7.78022C3.48332 88.8135 0 85.3302 0 81.0333V0.637695Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.22 60.8452C263.538 58.3553 257.879 57.4966 248.18 57.1972C238.703 56.9046 233.588 59.7394 224.14 59.229C214.197 58.6919 210.048 54.7512 200.1 54.2418C190.633 53.7569 185.447 57.2651 176.06 56.4121C165.397 55.4432 162.816 48.5064 152.02 48.608C140.882 48.7128 139.113 57.5993 127.98 57.3819C115.394 57.1361 114.157 45.1329 103.94 45.0984C93.723 45.0639 90.804 53.4554 79.9001 53.2343C64.0539 52.9129 67.5796 32.9901 55.8601 34.5349C44.1406 36.0797 46.77 74.7054 31.8201 72.6462C16.8703 70.5869 13.1516 34.5349 7.78018 8.41797",
    stroke: "#212121",
    strokeOpacity: 0.24,
    strokeWidth: 1.2967,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.14 59.229C233.588 59.7394 238.703 56.9046 248.18 57.1972C257.879 57.4966 263.538 58.3553 272.22 60.8452V81.0334H7.78018V8.41797C13.1516 34.5349 16.8703 70.5869 31.8201 72.6462C46.77 74.7054 44.1406 36.0797 55.8601 34.5349C67.5796 32.9901 64.0539 52.9129 79.9001 53.2343C90.8041 53.4554 93.723 45.0639 103.94 45.0984C114.157 45.1329 115.394 57.1361 127.98 57.3819C139.113 57.5993 140.882 48.7128 152.02 48.608C162.816 48.5063 165.397 55.4432 176.06 56.4121C185.447 57.2651 190.633 53.7569 200.1 54.2417C210.048 54.7512 214.197 58.6919 224.14 59.229Z",
    fill: "url(#paint0_linear_697_7928)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_697_7928",
    x1: 140,
    y1: 8.41797,
    x2: 140,
    y2: 81.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.4459af27e40a0b696de0c3d7a266cd85.svg";
export { ForwardRef as ReactComponent };